type TacitLogoProps = {
  className?: string;
};

export const TacitLogoStrategic = ({
  className = 'w-12 h-12',
}: TacitLogoProps): JSX.Element => {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Tacit CRM & Strategy"
    >
      <defs>
        <linearGradient
          id="tacit-gradient-v2"
          x1="20"
          y1="100"
          x2="80"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#6366F1" />
          <stop offset="100%" stopColor="#A78BFA" />
        </linearGradient>
        <filter id="kinetic-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      <g filter="url(#kinetic-glow)">
        <path
          d="M45 10 C 45 5, 55 5, 55 10 L 52 90 C 52 95, 42 95, 42 90 Z"
          fill="url(#tacit-gradient-v2)"
        />
        <path
          d="M15 35 C 10 38, 10 45, 15 42 L 85 22 C 90 19, 90 12, 85 15 Z"
          fill="white"
          fillOpacity="0.92"
        />
        <circle
          cx="78"
          cy="22"
          r="7"
          fill="#F59E0B"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          strokeOpacity="0.2"
        >
          <animate attributeName="r" values="7;8;7" dur="3s" repeatCount="indefinite" />
          <animate
            attributeName="fill-opacity"
            values="1;0.8;1"
            dur="3s"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </svg>
  );
};

export const TacitLogo = (props: TacitLogoProps): JSX.Element => {
  return <TacitLogoStrategic {...props} />;
};
